module.exports = __webpack_public_path__ + "static/media/mainpage.646e9f57.png";